import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Box, Button, Typography } from "@mui/material";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";

interface NoDataMessageProps {
  minHeight?: string;
  onClearFilters?: () => void;
}

export const NoDataMessage: FC<NoDataMessageProps> = ({ minHeight = "400px", onClearFilters }) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        minHeight,
        gap: "15px",
      }}
    >
      <FilterAltOffIcon sx={{ fontSize: "4rem", color: "#ccc" }} />
      <Typography variant="h5" sx={{ color: "#666" }}>
        {t("no_data.title")}
      </Typography>
      <Typography variant="body1" sx={{ color: "#999" }}>
        {t("no_data.description")}
      </Typography>
      {onClearFilters && (
        <Button variant="outlined" size="small" startIcon={<FilterAltOffIcon />} onClick={onClearFilters}>
          {t("clear_all_filters")}
        </Button>
      )}
    </Box>
  );
};

export default NoDataMessage;
